// import Table from 'ui/sites/table';
// import { BtnCreateSite } from 'ui/buttons';
import { CustomersTableSkeleton } from "ui/skeletons";
import { Suspense } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { BtnCreateSite } from "ui/buttons";
import Table from "ui/sites/table";

export default function Page() {
  const { orgid } = useParams();
  const orgId = orgid!;
  const [searchParams] = useSearchParams();
  const query = searchParams.get("query") || "";
  const currentPage = Number(searchParams.get("page")) || 1;

  return (
    <>
      {/* <div className="flex items-center justify-between gap-2"> */}
      {/* <Search placeholder="Search customers..." /> */}
      {/* <BtnCreateSite orgId={orgId} /> */}
      {/* </div> */}
      {/* <Suspense key={query + currentPage} fallback={<CustomersTableSkeleton />}> */}
      <Table orgId={orgId} />
      {/* </Suspense> */}
      <div className="mt-5 flex w-full justify-center">
        {/* <Pagination totalPages={numTotalPages} /> */}
      </div>
    </>
  );
}
